import {
  Button,
  Box,
  Typography,
  Grid,
  FormHelperText,
  IconButton,
  FormLabel,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";

import { useFormik } from "formik";
import * as yup from "yup";
import CustomTextField from "../../Components/TextField";
import { useErrorHandler } from "../../hooks";
import logo from "../../Assets/Images/logo.png";
import {
  RegisterAction,
  ClearAuthResponse,
} from "../../Redux/Actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from "react-loading";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./style.css";
import useToggle from "../../hooks/use-toggle";
import HelmetReact from "../../Components/Helmet";

function Register() {
  const { loading, success } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setMsgConfig } = useErrorHandler();
  const [visiblePassword, setVisiblePassword] = useToggle(true);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useToggle(true);
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      confirm_password: "",
    },

    enableReinitialize: true,
    validationSchema: yup.object({
      first_name: yup
        .string()
        .min(3, "Minimum 3 Characters Required")
        .required("First Name Required"),
      last_name: yup
        .string()
        .min(3, "Minimum 3 Characters Required")
        .required("Last Name Required"),
      email: yup
        .string()
        .required("Please Enter Email")
        .email()
        .matches(
          /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          "Please Enter Valid Email"
        ),

      password: yup
        .string()
        .required("Please Enter Password")
        .min(3, "Characters Must Be More Than 3")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          "Password Must Have 8 Characters,1 Special Character,1 UpperCase Letter,1 LowerCase Letter"
        ),
      confirm_password: yup
        .string()
        .required("Please Enter confirm Password")
        .min(3, "Characters Must Be More Than 3")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          "Password Must Have 8 Characters,1 Special Character,1 UpperCase Letter,1 LowerCase Letter"
        )
        .oneOf([yup.ref("password")], "Must Matching Password"),
    }),

    onSubmit: () => {
      let payload = {
        first_name: formik.values.first_name,
        last_name: formik.values.last_name,
        email: formik.values.email,
        password: formik.values.confirm_password,
        role: "doctor",
      };

      dispatch(RegisterAction(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Registered successfully!",
        severity: "success",
        autoHideDuration: 2000,
      });
    },
  });

  useEffect(() => {
    if (success == true) {
      navigate("/login");
      dispatch(ClearAuthResponse());
    }
  }, [success]);

  const registerBtn = useRef(null);
  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress, true);
  }, []);

  const handleKeyPress = (event) => {
    if (event?.key == "Enter") {
      registerBtn?.current?.click();
    }
  };

  return (
    <>
      <HelmetReact name="Register" />

      <Box className="loginForm register">
        <Box className="form-contianer register-form-contianer ">
          <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box>
          <Typography className="lable login-header" variant="h3">
            Sign Up New Account
          </Typography>

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="input login-input"
            >
              <FormLabel sx={{ display: "flex" }}>First Name*</FormLabel>
              <CustomTextField
                value={formik.values.first_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                id="first_name"
                name="first_name"
                error={
                  formik.touched.first_name && formik.errors.first_name
                    ? true
                    : false
                }
                placeholder="Enter first name *"
                fieldType="simpleTextInput"
              />

              {formik.touched.first_name && formik.errors.first_name && (
                <FormHelperText className="error_text_message">
                  {formik.errors.first_name}
                </FormHelperText>
              )}
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="input login-input"
            >
              <FormLabel sx={{ display: "flex" }}>Last Name*</FormLabel>

              <CustomTextField
                fieldType="simpleTextInput"
                value={formik.values.last_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                id="last_name"
                name="last_name"
                autoComplete="last_name"
                placeholder={"Enter last name *"}
                error={
                  formik.touched.last_name && formik.errors.last_name
                    ? true
                    : false
                }
              />
              {formik.touched.last_name && formik.errors.last_name && (
                <FormHelperText className="error_text_message">
                  {formik.errors.last_name}
                </FormHelperText>
              )}
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="input login-input"
            >
              <FormLabel sx={{ display: "flex" }}>Email Address*</FormLabel>

              <CustomTextField
                fieldType="simpleTextInput"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                id="email"
                name="email"
                autoComplete="email"
                placeholder="Enter your email *"
                error={
                  formik.touched.email && formik.errors.email ? true : false
                }
              />

              {formik.touched.email && formik.errors.email && (
                <FormHelperText className="error_text_message">
                  {formik.errors.email}
                </FormHelperText>
              )}
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="input login-input"
            >
              <FormLabel sx={{ display: "flex" }}>Password*</FormLabel>

              <CustomTextField
                fieldType="simpleTextInput"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                type={visiblePassword ? "password" : "text"}
                id="password"
                name="password"
                autoComplete="current-password"
                placeholder={"Enter password *"}
                error={
                  formik.touched.password && formik.errors.password
                    ? true
                    : false
                }
              />
              <IconButton className="toggle-eye" onClick={setVisiblePassword}>
                {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
              {formik.touched.password && formik.errors.password && (
                <FormHelperText className="error_text_message">
                  {formik.errors.password}
                </FormHelperText>
              )}
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="input login-input"
            >
              <FormLabel sx={{ display: "flex" }}>Confirm Password*</FormLabel>
              <CustomTextField
                fieldType="simpleTextInput"
                value={formik.values.confirm_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type={visibleConfirmPassword ? "password" : "text"}
                required
                id="confirm_password"
                name="confirm_password"
                autoComplete="current-password"
                placeholder={"Enter confirm password *"}
                error={
                  formik.touched.confirm_password &&
                  formik.errors.confirm_password
                    ? true
                    : false
                }
              />
              <IconButton
                className="toggle-eye"
                onClick={setVisibleConfirmPassword}
              >
                {visibleConfirmPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
              {formik.touched.confirm_password &&
                formik.errors.confirm_password && (
                  <FormHelperText className="error_text_message">
                    {formik.errors.confirm_password}
                  </FormHelperText>
                )}
            </Grid>
          </Grid>

          <Box className="form-custom-btn login-button">
            <Button
              variant="contained"
              onClick={formik.handleSubmit}
              onKeyDown={handleKeyPress}
              ref={registerBtn}
            >
              {loading ? (
                <Box className="outer_loader">
                  <ReactLoading
                    type={"spinningBubbles"}
                    height="30px"
                    width="30px"
                    color="#FFFFFF"
                  />
                </Box>
              ) : (
                "Register"
              )}
            </Button>
            <Grid className="link-custom" container>
              <Grid item xs className="forget-p text-center">
                <Link to="/login" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Register;
